import { render, staticRenderFns } from "./EnquiryReservationDelete.vue?vue&type=template&id=6234a3a4&scoped=true&"
import script from "./EnquiryReservationDelete.vue?vue&type=script&lang=js&"
export * from "./EnquiryReservationDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6234a3a4",
  null
  
)

export default component.exports